import { APICore } from './apiCore'

const api = new APICore()

function getInstanceSurveys (params) {
  const baseUrl = '/instance-survey'
  return api.get(baseUrl, params)
}

function getInstanceSurvey (id) {
  const baseUrl = `/instance-survey/${id}`
  return api.get(baseUrl, {})
}

function addInstanceSurvey (params) {
  const baseUrl = '/instance-survey'
  return api.create(baseUrl, params)
}

function updateInstanceSurvey (params) {
  const baseUrl = '/instance-survey'
  return api.update(baseUrl, params)
}

function deleteInstanceSurvey (params) {
  const baseUrl = '/instance-survey'
  return api.delete(baseUrl, params)
}

function addInstanceSurveyQr (params) {
  const baseUrl = '/instance-survey/qr'
  return api.create(baseUrl, params)
}

function updateInstanceSurveyQr (params) {
  const baseUrl = '/instance-survey/qr'
  return api.update(baseUrl, params)
}

export { getInstanceSurveys, getInstanceSurvey, addInstanceSurvey, updateInstanceSurvey, deleteInstanceSurvey, addInstanceSurveyQr, updateInstanceSurveyQr }
